/**
 * One tile's widget, with the tile it is in. The component is the registry's,
 * loaded as its own chunk the first time a tile shows it.
 */
import { Suspense } from "react";

import { widget } from "../widgets/registry";
import { Unknown } from "../widgets/Unknown";
import type { Slot } from "./layout";
import { TileCtx } from "./tile";

export function TileMount({ id, index, name }: { id: number; index: Slot; name: string }) {
  const entry = widget(name);
  const Component = entry?.component;
  return (
    <TileCtx.Provider value={{ id, index }}>
      {Component ? (
        <Suspense fallback={null}>
          <Component />
        </Suspense>
      ) : (
        <Unknown name={name} />
      )}
    </TileCtx.Provider>
  );
}
